/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react'
import { Row, Col, Input, Select, message, Modal, DatePicker, Form } from 'antd'
import { Link } from 'react-router-dom'
import _ from 'lodash'
import moment from 'moment'
import { observer, inject } from 'mobx-react'
import { compose } from 'recompose'
import { graphql } from 'react-apollo'
import gql from 'graphql-tag'

import ContituentSelect from '../../../../components/Custom/ConstituentSelect'
import ConstituentDetails from '../../details'

class Index extends Component {
	constructor(props) {
		super(props)

		this.state = {
			isSaving: false,
			selectedConstituent: null,
			didSelectConstituent: false,
			selectedOfficer: null,
			didSelectOfficer: false
		}
        
		this.handleSubmit = this.handleSubmit.bind(this)
	}
    
	handleSubmit(e) {
		e.preventDefault()
		const { selectedConstituent } = this.state
		const { form, AuthStore, saveCertificate, onClose } = this.props
		const { barangay_uid } = AuthStore
		const { resetFields } = form
		
		form.validateFields((err, values) => {
			if (err) {
				return false
			}

			const request_date = moment(values.request_date).format('YYYY-MM-DD HH:mm:ss')
			const or_issued_date = moment(values.or_issued_date).format('YYYY-MM-DD HH:mm:ss')
			let params = Object.assign({}, values, {
				barangay_uid,
				name: (!selectedConstituent.didSelectConstituent) ? selectedConstituent.name : `${selectedConstituent.first_name} ${selectedConstituent.middle_name || ''} ${selectedConstituent.last_name}`,
				constituent_uid: selectedConstituent.uid,
				request_date, or_issued_date
			})
			// console.log('params', params)

			message.loading({ key: 'set_certificate', content: 'Generating Certificate, please wait..' })
			this.setState({ isSaving: true }, () => {
				saveCertificate(params).then((response) => {
					const { file_url } = response.data.setCertificateBusinessClosure
					window.open(`${process.env.REACT_APP_BACKEND_API}${file_url}`, '_blank')
					this.setState({ isSaving: false })
					message.success({ key: 'set_certificate', content: 'Certificate successfully generated.' })

					//create audit trail
					const auditParams = {
						module_name: 'Certificate',
						action: 'Create',
						message: 'Generate Certificate of Business Closure'
					}
					AuthStore.saveAuditTrail(auditParams)

					onClose()
				}).catch(err => {
					this.setState({ isSaving: false })
					console.log('error generating certificate')
					message.error({ key: 'set_certificate', content: err.message.replace('GraphQL error:', '') })
					resetFields()
				})
			})
		})
	}

	render() {
		const { visible, onClose, form, AuthStore } = this.props
		const { getFieldDecorator } = form
		const { barangay_uid, or_required } = AuthStore
		const { selectedConstituent, isSaving } = this.state
		
		return (
			<Modal
				title="Business Closure"
				// placement="right"
				// closable={!isSaving}
				// onClose={onClose}
				visible={visible}
				width={'70%'}
				// bodyStyle={{ maxHeight: '90%', overflow: 'scroll' }}
				okText='Generate'
				maskClosable={!isSaving}
				onCancel={onClose}
				onOk={this.handleSubmit}
				confirmLoading={isSaving}
			>
				<Form onSubmit={this.handleSubmit}>
					{
						selectedConstituent &&
						<ConstituentDetails selectedConstituent={selectedConstituent} table_name='certificate_business_closure' />
					}
					<Row gutter={16}>
						<Col md={16} sm={24}>
							<Form.Item label='Constituent'>
								{ getFieldDecorator('constituent_uid', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<ContituentSelect 
										barangay_uid={barangay_uid}
										placeholder='Select Constituent Name'
										onSelectedItem={(item) => {
											if (item) {
												this.setState({ selectedConstituent: Object.assign({}, item, { didSelectConstituent: true }) })
											} else {
												this.setState({ selectedConstituent: null })
											}
										}}
									/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Request Date'>
								{ getFieldDecorator('request_date', {
									initialValue: moment(new Date()),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker format='LL' style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='O.R. Number'>
								{ getFieldDecorator('or_number', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter OR Number' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='O.R. Amount'>
								{ getFieldDecorator('amount', {
									rules: [{
										required: true,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input type='number' min={0} placeholder='Enter Amount' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='O.R. Issued Date'>
								{ getFieldDecorator('or_issued_date', {
									initialValue: moment(new Date()),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker format='LL' style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
						<Col md={24} sm={24}>
							<Form.Item label='Purpose of application'>
								{ getFieldDecorator('purpose', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input.TextArea rows={4} placeholder='Enter purpose of application here..' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Business Name'>
								{ getFieldDecorator('business_name', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter business name' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Line of Business'>
								{ getFieldDecorator('business_line', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter line of business' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Operator Name'>
								{ getFieldDecorator('operator_name', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter operator name' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Business Location'>
								{ getFieldDecorator('business_location', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input placeholder='Enter business location' />
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Date Started'>
								{ getFieldDecorator('date_started', {
									initialValue: moment(new Date()),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker format='LL' style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
						<Col md={8} sm={24}>
							<Form.Item label='Date Closed'>
								{ getFieldDecorator('date_closed', {
									initialValue: moment(new Date()),
									rules: [{
										required: true,
										message: 'This field is required.'
									}]
								})
								(
									<DatePicker format='LL' style={{ width: '100%' }}/>
								)}
							</Form.Item>
						</Col>
						<Col md={24} sm={24}>
							<Form.Item label='Reason of closure'>
								{ getFieldDecorator('reason_closure', {
									rules: [{
										required: false,
										message: 'This field is required.'
									}, {
										validator: (rule, value, callback) => {
											if (value && ((value.length > 0) && (!value.replace(/\s/g, '').length))) {
												callback('only white space detected.')
											}
											callback()
										}
									}]
								})
								(
									<Input.TextArea rows={2} placeholder='Enter reason of closure' />
								)}
							</Form.Item>
						</Col>
					</Row>
				</Form>
			</Modal>
		)
	}
}

const GENERATE_CERTIFICATE = gql`
    mutation setCertificateBusinessClosure($input: JSON) {
		setCertificateBusinessClosure(input: $input)
    }
`

const composed = compose(
	Form.create({ name: 'form-generate-certificate' }),
	inject('AuthStore'),
	graphql(GENERATE_CERTIFICATE, {
		props({ mutate }) {
			return {
				saveCertificate(params) {
					return mutate({
						variables: { input: params },
					  	refetchQueries: ['allCertificateBusinessClosure']
					})
				}
			}
		}
	}),
	observer
)

export default composed(Index)
